import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment'; // Wichtig für den Login-Status

@Injectable({
  providedIn: 'root',
})
export class FavoritesService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private apiUrl = environment.backend + '/favorites';

  private favoritesSubject = new BehaviorSubject<number[]>([]);
  public favorites$ = this.favoritesSubject.asObservable();

  constructor() {
    this.authService.currentUser$.subscribe((user) => {
      if (user) {
        this.fetchFavoriteIds();
      } else {
        this.favoritesSubject.next([]);
      }
    });
  }

  private fetchFavoriteIds(): void {
    this.http.get<number[]>(`${this.apiUrl}/ids`).subscribe((ids) => {
      this.favoritesSubject.next(ids);
    });
  }

  isFavorite(id: number): boolean {
    return this.favoritesSubject.getValue().includes(id);
  }

  toggleFavorite(id: number): void {
    const isCurrentlyFavorite = this.isFavorite(id);
    const currentFavorites = this.favoritesSubject.getValue();

    if (isCurrentlyFavorite) {
      this.http.delete(`${this.apiUrl}/${id}`).subscribe(() => {
        this.favoritesSubject.next(currentFavorites.filter((favId) => favId !== id));
      });
    } else {
      this.http.post(`${this.apiUrl}/${id}`, {}).subscribe(() => {
        this.favoritesSubject.next([...currentFavorites, id]);
      });
    }
  }
}
